export const asrLanguages = [
    { key: 'English', value: 'english' },
    { key: 'Malay', value: 'malay' },
    { key: 'Mandarin', value: 'mandarin' },
    { key: 'Eng - Malay (Codeswitch)', value: 'english-malay' },
    { key: 'Eng - Mandarin (Codeswitch)', value: 'english-mandarin' },
]
